import VOtpInput from './VOtpInput'

export { VOtpInput }
export default VOtpInput
